/**
 * 水印叠加预设动作
 * 
 * 步骤：
 * 1. 将第一个图层重命名为底图
 * 2. 将第二个图层重命名为水印
 * 3. 对水印图层执行反相操作
 * 4. 对水印图层应用2px的高斯模糊
 * 5. 设置水印图层的混合模式为正片叠底
 */

// 对图层应用反相滤镜
function applyInvertFilter(layerCanvas) {
  if (!layerCanvas) return false;
  
  const ctx = layerCanvas.getContext('2d');
  const imageData = ctx.getImageData(0, 0, layerCanvas.width, layerCanvas.height);
  const data = imageData.data;
  
  // 反相操作
  for (let i = 0; i < data.length; i += 4) {
    data[i] = 255 - data[i];         // 红
    data[i + 1] = 255 - data[i + 1]; // 绿
    data[i + 2] = 255 - data[i + 2]; // 蓝
    // 不修改 alpha 通道
  }
  
  ctx.putImageData(imageData, 0, 0);
  return true;
}

// 水印叠加预设的执行函数
export default function watermarkOverlay(context) {
  const { layers, layerCanvases, updateLayerThumbnail, redrawCanvas } = context;
  
  console.log('执行水印叠加预设...');
  
  try {
    // 确保有足够的图层
    if (layers.length < 2) {
      throw new Error('水印叠加预设需要至少两个图层');
    }
    
    // 1. 将第一个图层重命名为底图
    layers[0].name = '底图';
    
    // 2. 将第二个图层重命名为水印
    layers[1].name = '水印';
    
    // 3. 将水印图层执行反相操作
    const watermarkLayerId = layers[1].id;
    const watermarkCanvas = layerCanvases[watermarkLayerId];
    
    if (!applyInvertFilter(watermarkCanvas)) {
      throw new Error('无法对水印图层应用反相效果');
    }
    
    // 4. 将水印图层执行2px的高斯模糊
    layers[1].filters.blur = 2;
    
    // 5. 应用混合模式为正片叠底
    // layers[1].blendMode = 'multiply';
    
    // 更新缩略图
    updateLayerThumbnail(0);
    updateLayerThumbnail(1);
    
    // 重绘画布
    redrawCanvas();
    
    console.log('水印叠加预设执行完成');
    return true;
  } catch (error) {
    console.error('执行水印叠加预设时出错:', error);
    return false;
  }
} 